import { graphql } from '~/gql';

export const ExpertDocument = graphql(`
  query Expert($expertId: BigInt!) {
    expert(expertId: $expertId) {
      id
      email
      name
      avatarUrl
      status
      hourlyRate
      linkedinProfileUrl
      willingToTravel
      previouslyTestified
      professionalSummary
      professionalPrefix
      professionalSuffix
      industries {
        name
      }
      specialties {
        name
      }
      subspecialties {
        name
      }
      statesOfPractice {
        name
      }
      yearsExperience
      credentials {
        name
        institution
        year
      }
      certifications {
        name
        board
        year
        expirationYear
      }
      licenses {
        name
        issuer
        number
        status
      }
      professionalExperience {
        role
        institution
        startYear
        endYear
        summary
      }
      publications {
        publication
        topic
        publicUrl
      }
    }
  }
`);
